// extracted by mini-css-extract-plugin
export default {"game":"yisklUpWOXH5MHx5IqsQ","board":"y6vmCWldKUib8fxV4ESx","boardTile":"_OL2_Evd4IhWEgrcMzwz","bingo":"kTr5Xcw2xaQPkXzA1pUx","newGameButton":"AxU0prZZUbshiJ7K0HPw"};